import { Box, Grid, styled, TextField } from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FullpageLoader from "../../components/fullPageLoader";
import { ReportsTypeContext } from "../../context/userIReports";
import { contactsService } from "../../services/contactsService";
import {
  setSelectedRow,
  setSelectedRowDetails,
} from "../../store/actions/reportTypeAction";
import  { SnackBarCompV2 } from "../../components/snackBar";
import ReportDetailsV2 from "../progressWeek/ReportDetailsV2";
import NewButton from "../../components/NewButton";
import LogoTNT from "../../assets/images/icon/LogoTNT";
import CommonTypo from "../../components/CommonTypo";

const RootStyle = styled("div")(({ theme }) => ({
  padding: "56px 32px",
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  alignSelf: "stretch",
  width: "100%",
  height: "100vh",
  overflowY: "auto",
  [theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
  },
  [theme.breakpoints.down(1001)]: {
    padding: "20px",
  },
}));

const ShareViewReportV2 = () => {
  const { state: IReportTypeContext, dispatch: reportTypeDispatch } =
    useContext(ReportsTypeContext);
  const { end, start, uid, shareReportId, from, to, email, feedbackId } = useParams();
  const [dates, setDates] = useState([]);
  const [userData, setUserData] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [replyInput, setReplyInput] = useState(null);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [showSnakbar, setShowSnakbar] = useState(false);
  const [showSuccessMessage, setSuccessMessage] = useState(null);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  useEffect(() => {
    if (shareReportId) {
      const objToSahre = {
        shareReportId,
        feedbackId
      }
      contactsService
        .getReportDetails(objToSahre)
        .then((data) => {
          if(data.feedback && feedbackId) {
            setFeedback(data.feedback)
            setReplyInput(data.feedback.comment)
          }
          if (data.body.from && data.body.to && data.body.uid) {
            setUserData(data.userData);
            const startDate = moment(from || data.body.from).format("YYYY-MM-DD");
            const endDate = moment(to || data.body.to).subtract(to ? 1 : 0, "day").format("YYYY-MM-DD");
            reportTypeDispatch(
              setSelectedRow({
                till: endDate,
                from: startDate,
                uid: data.body.uid,
              })
            );
            contactsService
              .viewshareReport({
                to: to || data.body.to,
                from: from || data.body.from,
                uid: data.body.uid,
                outcomeIds: data.body.outcomeIds,
                influenceIds: data.body.influenceIds,
              })
              .then((data) => {
                reportTypeDispatch(setSelectedRowDetails(data));
                // setShowSnakbar(true);
                // setMsgType("success");
                // setSnakbarMsg(data?.description);
              })
              .catch((err) => {
                if (err?.description) {
                  //   setShowSnakbar(true);
                  //   setMsgType("error");
                  //   setSnakbarMsg(err?.description);
                }
              });
          }
        })
        .finally(() => {
          // setShowLoadingBtn(false)
        });
    }
    // if (end && start && uid) {
    //     const startDate = moment(start).add(1, 'day').format("YYYY-MM-DD");
    //     const endDate = moment(end).add(1, 'day').format("YYYY-MM-DD");
    //     reportTypeDispatch(setSelectedRow({ till: endDate, from: startDate, uid }))
    //     contactsService.viewshareReport({ to: end, from: start, uid }).then(data => {
    //         reportTypeDispatch(setSelectedRowDetails(data))
    //         // setShowSnakbar(true);
    //         // setMsgType("success");
    //         // setSnakbarMsg(data?.description);
    //     }).catch(err => {
    //         if (err?.description) {
    //             //   setShowSnakbar(true);
    //             //   setMsgType("error");
    //             //   setSnakbarMsg(err?.description);
    //         }

    //     }).finally(() => {
    //         // setShowLoadingBtn(false)
    //     })
    // }
  }, [end, start, uid, shareReportId]);
  const submitFeedback = () => {
    contactsService
      .addFeedback({
        shareReportId,
        date: moment().format("MM-DD-YYYY"),
        comment: replyInput,
        email: email,
      })
      .then((data) => {
        setFeedbackSubmitted(true)
        setShowSnakbar(true);
        setMsgType("success");
        setSnakbarMsg("Feedback submitted");
        setTimeout(() => {
          setShowSnakbar(false);
          setMsgType("success");
          setSnakbarMsg("");
        }, 3000);
      })
      .catch((err) => {
        if (err?.description) {
          //   setShowSnakbar(true);
          //   setMsgType("error");
          //   setSnakbarMsg(err?.description);
        }
      });
  };
  const enumerateDaysBetweenDates = (startDate, endDate) => {
    var dates = [];
    var currDate = moment(startDate, "MM-DD-YYYY")
      .subtract(1, "day")
      .startOf("day");
    var lastDate = moment(endDate, "MM-DD-YYYY").endOf("day");

    while (currDate.add(1, "days").diff(lastDate) < 0) {
      dates.push(currDate.clone().toDate());
    }
    setDates(dates);
  };
  useEffect(() => {
    if (Object.keys(IReportTypeContext.selectedRow).length) {
      enumerateDaysBetweenDates(
        IReportTypeContext.selectedRow.from,
        IReportTypeContext.selectedRow.till
      );
    } else {
      setDates([]);
    }
    return () => setDates([]);
  }, [IReportTypeContext.selectedRow]);
  return (
    <Grid
      container
      columns={16}
      height={"100vh"}
      className="tracking_container"
      sx={{ boxSizing: "border-box", overflowY: "auto" }}
    >
      {showLoader && <FullpageLoader />}
      <SnackBarCompV2
        showSnakbar={showSnakbar}
        handleCloseSnakbar={() => {
          setShowSnakbar(false);
        }}
        
        snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color="var(--color-text-primary)">{snakbarMsg}</CommonTypo>}
        type={msgType ? msgType : "success"}
        alertSx={{
          background: "var(--color-new-main)",
          boxShadow: "0px 4px 8px 0px #0000001A",
          padding: "16px",
          borderRadius: "12px",
          height: "52px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          "& .MuiAlert-icon": {
            marginRight: "0px"
          }
        }}
        icon={msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
        </svg> : null
        }
      />
      <Grid item className="track-body-grid" width={"100% !important"}>
        <RootStyle
          // className="track-body"
          sx={{
            background: "#fff",
          }}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            alignSelf={"stretch"}
            justifyContent={"center"}
            width={"100%"}
            gap={"16px"}
          >
            <Box
              display={"inline-flex"}
              alignItems={"center"}
              flexDirection={"column"}
              justifyContent={"center"}
              width={"72px"}
              height={"72px"}
              padding={"14.4px"}
              borderRadius={"180px"}
              sx={{
                background: "var(--color-new-main)",
              }}
            >
              <LogoTNT />
            </Box>
            <CommonTypo
              size={32}
              lineHeight={38.4}
              fontWeight={700}
              color="var(--color-text-primary)"
            >
              Weekly report from {userData.first_name}
            </CommonTypo>
            <CommonTypo
              size={16}
              lineHeight={19.2}
              fontWeight={400}
              color="var(--color-text-primary)"
            >
              {moment(from || IReportTypeContext.selectedRow.from).format("DD MMM")} -{" "}
              {moment(to || IReportTypeContext.selectedRow.till).subtract(to ? 1 : 0, "day").format("DD MMM")},{" "}
              {moment(from || IReportTypeContext.selectedRow.from).format("YYYY") ===
              moment(to || IReportTypeContext.selectedRow.till).subtract(to ? 1 : 0, "day").format("YYYY")
                ? moment(to || IReportTypeContext.selectedRow.till).subtract(to ? 1 : 0, "day").format("YYYY")
                : `${moment(from || IReportTypeContext.selectedRow.from).format(
                    "YYYY"
                  )} - ${moment(to || IReportTypeContext.selectedRow.till).subtract(to ? 1 : 0, "day").format(
                    "YYYY"
                  )}`}
            </CommonTypo>
          </Box>
          {userData && userData.user_email && feedbackId && (
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              minWidth={"calc(100% - 400px)"}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                gap={"16px"}
                alignSelf={"stretch"}
                minWidth={"55%"}
                justifyContent={"center"}
              >
                <CommonTypo
                  size={24}
                  lineHeight={28.8}
                  fontWeight={700}
                  color="var(--color-text-primary)"
                >
                  {feedback && feedback?.contactName}'s reply
                </CommonTypo>
                <TextField
                  placeholder="Please, share your feedback..."
                  multiline
                  minRows={15}
                  maxRows={15}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  // className="textarea"
                  fullWidth
                  sx={{
                    border: "1px solid var(--color-border) !important",
                    alignSelf: "stretch",
                    borderRadius: "12px",
                    marginBottom: "0px !important",
                    "& .MuiInputBase-root": {
                      borderRadius: "12px !important",

                      "& .MuiInputBase-input": {
                        borderRadius: "12px",
                        padding: "16px !important",
                        minHeight: "253px !important",
                        height: "253px !important",
                        "&::placeholder": {
                          color: "var(--color-text-primary)",
                          opacity: 1,
                          fontSize: "16px",
                        },
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        display: "none",
                      },
                    },
                  }}
                  onChange={(e) => {
                    setReplyInput(replyInput);
                  }}
                  value={replyInput}
                />
              </Box>
            </Box>
            // <div
            //   style={{
            //     display: "flex",
            //     flexDirection: "column",
            //     gap: "16px",
            //     margin: "70px 0px 30px",
            //   }}
            // >
            //   <Typography
            //     sx={{
            //       width: "100%",
            //       color: palette.common.black,
            //       fontSize: `${pxToRem(18)} !important`,
            //       fontWeight: 400,
            //     }}
            //   >
            //     Got feedback or some encouragement for{" "}
            //     {userData && userData.first_name
            //       ? ` ${userData.first_name}`
            //       : ""}
            //     ? Just hit reply and share your thoughts!
            //   </Typography>
            //   <div>
            //     <NewButton
            //       buttonText="Reply"
            //       padding="15px 16px 15px 16px"
            //       boxPadding="0px 16px 0px 16px"
            //       onClick={() => {
            //         window.open(
            //           `https://mail.google.com/mail/?compose=new&to=${userData.user_email}`,
            //           "__blank"
            //         );
            //       }}
            //     />
            //   </div>
            // </div>
          )}
          <ReportDetailsV2 isFromShare={true} />
          {userData && userData.user_email && !feedbackId && (
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              minWidth={"calc(100% - 400px)"}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                gap={"16px"}
                alignSelf={"stretch"}
                minWidth={"55%"}
                justifyContent={"center"}
              >
                <CommonTypo
                  size={24}
                  lineHeight={28.8}
                  fontWeight={700}
                  color="var(--color-text-primary)"
                >
                  Your reply
                </CommonTypo>
                <TextField
                  placeholder="Please, share your feedback..."
                  multiline
                  minRows={15}
                  maxRows={15}
                  variant="outlined"
                  // className="textarea"
                  InputProps={{
                    readOnly: feedbackSubmitted
                  }}
                  fullWidth
                  sx={{
                    border: "1px solid var(--color-border) !important",
                    alignSelf: "stretch",
                    borderRadius: "12px",
                    marginBottom: "0px !important",
                    "& .MuiInputBase-root": {
                      borderRadius: "12px !important",

                      "& .MuiInputBase-input": {
                        borderRadius: "12px",
                        padding: "16px !important",
                        minHeight: "253px !important",
                        height: "253px !important",
                        "&::placeholder": {
                          color: "var(--color-text-primary)",
                          opacity: 1,
                          fontSize: "16px",
                        },
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        display: "none",
                      },
                    },
                  }}
                  onChange={(e) => {
                    setReplyInput(e.target.value);
                  }}
                  value={replyInput}
                />
                {!feedbackSubmitted && <NewButton
                  buttonText="Send"
                  extraSx={{
                    minWidth: "312px",
                    padding: "16px",
                    height: "40px",
                  }}
                  isDisabled={!(replyInput && replyInput.length > 0)}
                  onClick={submitFeedback}
                  boxSx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  padding="16px"
                  borderRadius="20px"
                />}
              </Box>
            </Box>
            // <div
            //   style={{
            //     display: "flex",
            //     flexDirection: "column",
            //     gap: "16px",
            //     margin: "70px 0px 30px",
            //   }}
            // >
            //   <Typography
            //     sx={{
            //       width: "100%",
            //       color: palette.common.black,
            //       fontSize: `${pxToRem(18)} !important`,
            //       fontWeight: 400,
            //     }}
            //   >
            //     Got feedback or some encouragement for{" "}
            //     {userData && userData.first_name
            //       ? ` ${userData.first_name}`
            //       : ""}
            //     ? Just hit reply and share your thoughts!
            //   </Typography>
            //   <div>
            //     <NewButton
            //       buttonText="Reply"
            //       padding="15px 16px 15px 16px"
            //       boxPadding="0px 16px 0px 16px"
            //       onClick={() => {
            //         window.open(
            //           `https://mail.google.com/mail/?compose=new&to=${userData.user_email}`,
            //           "__blank"
            //         );
            //       }}
            //     />
            //   </div>
            // </div>
          )}
        </RootStyle>
      </Grid>
    </Grid>
  );
};

export default ShareViewReportV2;
